import React from "react";
import { renderMobile } from "../MobileMenu";
import { MExpandable } from "./Expandable";
import { _t } from "app/i18n/i18n";

export const Parent = (item) => {
  if (item.menu === "Home") return item.children[0].children.map(renderMobile);
  const label = item.menu || item.heading || item.group || "";
  return <MExpandable label={_t(label)}>{item.children.map(renderMobile)}</MExpandable>;
};
